import "./Work";
import "./Work.css"
import Excel from "./Excel"

import React, { useState } from 'react';

export default function Work() {

 const [content, setContent] = useState('Click a button to change this content!');
 const [test1visible, setTest1Visible] = useState(false);
 const [test2visible, setTest2Visible] = useState(false);
 const [test3visible, setTest3Visible] = useState(false);
 const [test4visible, setTest4Visible] = useState(false);

  const test1 = () => {
	setTest1Visible(!test1visible);

	setTest2Visible(false);
	setTest3Visible(false);
	setTest4Visible(false);
  };

  const test2 = () => {
	setTest2Visible(!test2visible);

	setTest1Visible(false);
	setTest3Visible(false);
	setTest4Visible(false);
  };

  const test3 = () => {
	setTest3Visible(!test3visible);

	setTest1Visible(false);
	setTest2Visible(false);
	setTest4Visible(false);
  };

  const test4 = () => {
	setTest4Visible(!test4visible);

	setTest1Visible(false);
	setTest2Visible(false);
	setTest3Visible(false);
  };

    return (
<>
  <div className="menu">
    <button onClick={() => test1()} className="btn">
      excel
    </button>
    <button onClick={() => test2()} className="btn">
      test2
    </button>
    <button onClick={() => test3()} className="btn">
      test3
    </button>
    <button onClick={() => test4()} className="btn">
      test4
    </button>
  </div>
  <div className="test-content" hidden={!test1visible}>
    <div className="admin-content">
	    <Excel />
    </div>
  </div>
  <div className="test-content" hidden={!test2visible}>
    <div className="admin-content">
	    <h1>testing2</h1>
    </div>
  </div>
  <div className="test-content" hidden={!test3visible}>
    <div className="admin-content">
	    <h1>testing3</h1>
    </div>
  </div>
  <div className="test-content" hidden={!test4visible}>
    <div className="admin-content">
	    <h1>testing4</h1>
    </div>
  </div>
</>
  );
}
